import { forwardRef, type Ref, type SVGProps } from "react";

function SvgList(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.944 4H4.056C3.196 4 2.5 4.672 2.5 5.5S3.196 7 4.056 7h8.888c.86 0 1.556-.672 1.556-1.5S13.804 4 12.944 4m0 6H4.056c-.86 0-1.556.672-1.556 1.5S3.196 13 4.056 13h8.888c.86 0 1.556-.672 1.556-1.5s-.696-1.5-1.556-1.5"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
